import { MessageCircle } from "lucide-react";

/**
 * Botão flutuante de WhatsApp para CTAs nas páginas públicas.
 * Número padrão da unidade VM Corporate Piabetá.
 */
const WHATSAPP_NUMBER = "5521975968405";
const DEFAULT_MSG = "Olá! Quero conhecer o VM Corporate em Piabetá e agendar um tour gratuito.";

export default function WhatsAppFloat({ message = DEFAULT_MSG, position = "bottom-right" }) {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      data-testid="whatsapp-float"
      className={`fixed ${position === "bottom-right" ? "bottom-6 right-4 sm:right-6" : "bottom-6 left-4 sm:left-6"} z-40 inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white pl-4 pr-5 py-3 rounded-full shadow-lg shadow-emerald-500/30 transition-all hover:scale-105`}
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline font-semibold text-sm">WhatsApp</span>
    </a>
  );
}
